// extracted by mini-css-extract-plugin
export default {"wrapper":"MessageGroup_wrapper__0la7y","modalImg":"MessageGroup_modalImg__DF+5X"};